import { FC, useContext, useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";

import StepperModal from "../stepperModal";

import { onGoingTreatmentPropsType, QueryParamsState } from "./types";
import { isMobileOrTablet, objectToQueryString } from "src/helpers";
import {  ONGOING_TREATMENTS_HEADER } from "src/constants/manufacturer";
import { AuthContext } from "src/context/authContext";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import PracticeContactInfo from "src/components/practiceContactInfo";
import { onGoingTreatmentType } from "src/pages/territories/types";
import { sortTableColumns } from "src/helpers/stats";
import TableHeader from "src/components/tableHeader";



const OngoingTreatment: FC<onGoingTreatmentPropsType> = ({ type, baseUrl, searchParams, CaseDetailListType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [caseDetails, setCaseDetails] = useState<any>(null);
  const [caseListing, updateCaseListing] = useState<onGoingTreatmentType[]>([])
  const [queryParams, updateQueryParams] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "case_id",
  });
  const { userData } = useContext(AuthContext)
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);
  useOnClickOutside(toggleIconRef, () => changeInfoIconIndex(-1))

  useEffect(() => {
    if (CaseDetailListType.length > 0) {
      const caseListings = CaseDetailListType.map((item) => ({...item, doc_name:item?.provider?.doc_name}))
      updateCaseListing(caseListings)
      updateQueryParams({direction:"desc",sort_by:""})
    }
  }, [CaseDetailListType]);

  const openModal = (caseItem: any) => {
    setModal(true);
    setCaseDetails(caseItem);
  };

  const changeIdOrder = (tableHeader: string) => {
    // const updatedQueryParams: QueryParamsState = {
    //   sort_by: tableHeader,
    //   direction: tableHeader === queryParams.sort_by ? (queryParams.direction === "desc" ? "asc" : "desc") : "desc"
    // };

    // switch (updatedQueryParams.sort_by) {
    //   case "case_id":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.case_id) - Number(item2.case_id);
    //       else
    //         return Number(item2.case_id) - Number(item1.case_id);
    //     });
    //     break;

    //   case "patient_id":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.global_patient_id) - Number(item2.global_patient_id);
    //       else
    //         return Number(item2.global_patient_id) - Number(item1.global_patient_id);
    //     });
    //     break;

    //   case "bi_ct":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.bi_ct) - Number(item2.bi_ct);
    //       else
    //         return Number( item2.bi_ct) - Number(item1.bi_ct);
    //     });
    //     break;

    //   case "qty":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return Number(item1.qty || 0) - Number(item2.qty || 0);
    //       else
    //         return Number(item2.qty || 0) - Number(item1.qty || 0);
    //     });
    //     break;
    //   case "Prevous_treatment_date":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return new Date(item1.treated_at).getTime() - new Date(item2.treated_at).getTime();
    //       else
    //         return new Date(item2.treated_at).getTime() - new Date(item1.treated_at).getTime();
    //     });
    //     break;
    //   // case "received":
    //   //   CaseDetailListType.sort((item1, item2) => {
    //   //     if (updatedQueryParams.direction === "asc")
    //   //       return (item1.received || "").localeCompare(item2.received || "");
    //   //     else
    //   //       return (item2.received || "").localeCompare(item1.received || "");
    //   //   });
    //   //   break;

    //   // case "completed":
    //   //   CaseDetailListType.sort((item1, item2) => {
    //   //     if (updatedQueryParams.direction === "asc")
    //   //       return (item1.completed || "").localeCompare(item2.completed || "");
    //   //     else
    //   //       return (item2.completed || "").localeCompare(item1.completed || "");
    //   //   });
    //   //   break;
    //   case "insurance_name":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return (item1.insurance_name || "").localeCompare(item2.insurance_name || "");
    //       else
    //         return (item2.insurance_name || "").localeCompare(item1.insurance_name || "");
    //     });
    //     break;
    //   case "case_status":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return (item1.status_name || "").localeCompare(item2.status_name || "");
    //       else
    //         return (item2.status_name || "").localeCompare(item1.status_name || "");
    //     });
    //     break;
    //   case "provider.doc_name":
    //     CaseDetailListType.sort((item1, item2) => {
    //       if (updatedQueryParams.direction === "desc")
    //         return item1.provider.doc_name.localeCompare(item2.provider.doc_name);
    //       else
    //         return item2.provider.doc_name.localeCompare(item1.provider.doc_name);
    //     });
    //     break;
    // }

    // updateQueryParams(updatedQueryParams);
    sortTableColumns(tableHeader, queryParams, updateQueryParams, caseListing, updateCaseListing)
  };

  return (
    <>
      <div className="card">
        <div className="card-header bg-success-subtle">
          <h4 className="text-center text-black m-0">Ongoing Treatments</h4>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive overflow-auto" style={{ minHeight: "50px", maxHeight: "350px" }}>

            <table className="table table-sm mb-0 case-detail-thead">
              <thead className="sticky-top">
                <tr>
                  {ONGOING_TREATMENTS_HEADER.map((tableHeader, index) => (
                    <TableHeader
                      key={index} tableHeader={{...tableHeader,width:`${tableHeader.width}px`}} sortConfig={queryParams}
                      changeIdOrder={changeIdOrder} classNames="text-center"
                    />
                  ))}
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {caseListing &&
                  caseListing.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td className="text-center">
                        <button className="btn btn-blue btn-case rounded-0" onClick={() => openModal(item)}>
                          {item?.case_id}
                        </button>
                      </td>
                      <td className="text-center">
                        <Link
                           to={{
                            pathname: baseUrl+`/${searchParams.id}`,
                            search: objectToQueryString(baseUrl === `/territories` ? {
                              role:type === "doctor" ? "doctor" : userData?.ref_type?.toLowerCase() ?? '',
                              search_str:item.global_patient_id,
                              type: type,
                              id: searchParams.id,
                            } : {
                              id: searchParams.id,
                              filter_type: searchParams.filter_type,
                              role: type === "doctor" ? "doctor" : userData?.ref_type?.toLowerCase() ?? '',
                              period: searchParams.period,
                              global_patient_external_id: item.global_patient_id,
                              search_str:item.global_patient_id,
                              type: searchParams.type,
                            }
                          )
                          }}
                          reloadDocument
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >
                          {item?.global_patient_id}
                        </Link>
                      </td>
                      <td className="text-center">{item?.bi_ct}</td>
                      <td className="text-center">{item?.qty}</td>
                      <td className='text-center'>{item.treated_at}</td>
                      <td className="text-center">{item.insurance_name}</td>
                      <td className="text-center">{item?.outcome}</td>
                      <td className="text-center">{item?.rx_cvg}</td>
                      <td className="text-center">{item?.med_cvg}</td>
                      <td className='text-center'>{item?.rx_pa}</td>
                      <td className="text-center">{item?.med_pa}</td>
                      
                      <td className={`text-center align-middle text-white background-color-${item && item.color_idx ? item.color_idx : 1}`}
                        style={{ minWidth: "200px" }}>
                        {item.status_name}
                      </td>
                      <td className="text-center text-white" style={{backgroundColor:"#5bc0de"}}>{item.retreatment_status === '12' ? 'Eligible' : 'Inprocess'}</td>
                      <td className="text-center">
                        <Link 
                          to={{
                            pathname: `/doctor_stats/${item.provider.doctor_id}`,
                            search: objectToQueryString({
                              id: item.provider.doctor_id,
                              type: "doctor",
                              role: "doctor",
                            })
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                          title={item && item.provider ? 
                            `${`Practice: ${item?.provider?.practice_name ?? ""}`}\n\n${`Address: ${item?.provider?.address ?? ""}`}\n\n${`Phone: ${item?.provider?.phone ?? ""}`}\n\n${`Fax: ${item?.provider?.fax ?? ""}`}`
                          : ""}
                        >
                          {item?.provider.doc_name}
                        </Link>
                        {item && isMobileOrTablet() &&
                          <PracticeContactInfo
                            children={<i className="bi bi-exclamation-circle-fill ms-1"></i>}
                            name={item?.provider?.practice_name ?? ""} 
                            address={item?.provider?.address ?? ""}
                            phone={item?.provider?.phone ?? ""}
                            fax={item?.provider?.fax ?? ""}
                            indexKey={index}
                          />
                        }
                      </td>

                    </tr>
                  ))
                }
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div className="col-8">      
        {/* {showingModal ?
         <StepperModal
        onClick={() => {
          setModal(false);
          setCaseDetails(null);
        }}
        caseDetails={caseDetails}
    /> : null} */}
     {showingModal ? (
            <StepperModal
                onClick={() => {
                  setModal(false);
                  setCaseDetails(null);
                }}
                caseId={caseDetails.case_id}
            />
        ) : null}
      </div>   
     </>
  );
};

export default OngoingTreatment;
